import LocalStorageUtils from './LocalStorageUtils';
import axios from 'axios';

const ACCESS_TOKEN_KEY: string = 'access_token';
const CURRENT_USER_KEY: string = 'currentUser';

export default class AuthenticationUtils {
  public static dataLoaded: boolean = false;
  public static accessToken: string;
  public static currentUser: any;

  public static isAuthenticated(): boolean {
    AuthenticationUtils.loadDataIfNeed();
    return !!AuthenticationUtils.accessToken;
  }

  public static updateAxiosHeader() {
    const authorizationHeader = 'Authorization';
    axios.defaults.headers.common[authorizationHeader] = `Bearer ${AuthenticationUtils.getAccessToken()}`;
  }

  public static saveAuthenticationData(data: any) {
    const {access_token, currentUser} = data;
    this.updateAccessToken(access_token);

    LocalStorageUtils.saveItem(CURRENT_USER_KEY, currentUser);
    AuthenticationUtils.currentUser = currentUser;
  }

  public static saveCurrentUser(currentUser: any) {
    LocalStorageUtils.saveItem(CURRENT_USER_KEY, currentUser);
    AuthenticationUtils.currentUser = currentUser;
  }

  public static updateAccessToken(accessToken: any) {
    LocalStorageUtils.saveItem(ACCESS_TOKEN_KEY, accessToken);
    AuthenticationUtils.accessToken = accessToken;
    AuthenticationUtils.updateAxiosHeader();
  }

  public static removeAuthenticationData() {
    LocalStorageUtils.removeItem(ACCESS_TOKEN_KEY);
    LocalStorageUtils.removeItem(CURRENT_USER_KEY);
    AuthenticationUtils.accessToken = '';
    AuthenticationUtils.currentUser = {};
    AuthenticationUtils.updateAxiosHeader();
  }

  public static getAccessToken(): string {
    AuthenticationUtils.loadDataIfNeed();

    return AuthenticationUtils.accessToken;
  }

  public static getCurrentUser(): any {
    AuthenticationUtils.loadDataIfNeed();

    return AuthenticationUtils.currentUser;
  }

  public static loadData() {
    AuthenticationUtils.accessToken = LocalStorageUtils.getItem(ACCESS_TOKEN_KEY) || '';
    AuthenticationUtils.currentUser = LocalStorageUtils.getItem(CURRENT_USER_KEY) || {};
    AuthenticationUtils.dataLoaded = true;
  }

  public static loadDataIfNeed() {
    if (AuthenticationUtils.dataLoaded === undefined || !AuthenticationUtils.dataLoaded) {
      AuthenticationUtils.loadData();
    }
  }
}
